import { render, staticRenderFns } from "./ListDialog.vue?vue&type=template&id=72bf3e10&scoped=true"
import script from "./ListDialog.vue?vue&type=script&lang=ts"
export * from "./ListDialog.vue?vue&type=script&lang=ts"
import style0 from "./ListDialog.vue?vue&type=style&index=0&id=72bf3e10&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf3e10",
  null
  
)

export default component.exports